import React from 'react'
import { Adsense } from '@ctrl/react-adsense'

const AD_SLOTS = {
  display: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT,
  inArticle: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT_IN_ARTICLE,
  inFeed: process.env.REACT_APP_GOOGLE_ADSENSE_SLOT_IN_FEED
}

export const ReactAdSense = ({ adPosition, adUnit = 'display', adClass }) => {
  const commonProps = {
    className: adClass,
    client: process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT,
    slot: AD_SLOTS[adUnit] || process.env.REACT_APP_GOOGLE_ADSENSE_SLOT
  }

  // Explore Menu will always be inFeed
  const shouldBeInFeedAd = adPosition === 'explore-more-content' || adPosition === 'menu-button'
  if (shouldBeInFeedAd) {
    return (
      <Adsense
        style={{ display: 'block' }}
        format='fluid'
        layoutKey='-fb+5w+4e-db+86'
        className={adClass}
        client={process.env.REACT_APP_GOOGLE_ADSENSE_CLIENT}
        slot={AD_SLOTS.inFeed}
      />
    )
  }

  switch (adUnit) {
    case 'inArticle':
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block', textAlign: 'center' }}
          format='fluid'
          layout='inArticle'
        />
      )

    case 'inFeed':
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block' }}
          format='fluid'
          layoutKey='-fb+5w+4e-db+86'
        />
      )

    case 'display':
    default:
      return (
        <Adsense
          {...commonProps}
          style={{ display: 'block' }}
          format='auto'
          responsive='true'
        />
      )
  }
}
